import { generateUUID } from "./uuid";

export const getOrCreateSessionUUID = (key) => {
  let id = sessionStorage.getItem(key);

  if (!id) {
    id = generateUUID();
    sessionStorage.setItem(key, id);
  }

  return id;
};

export const clearSessionUUID = (key) => {
  sessionStorage.removeItem(key);
};